export const environment = {
  production: true,
  authConfig: {
    clientId: '0oa21jangclxI66s40h8',
    issuer: 'https://sso.uat.verisk.com/oauth2/aus10avte3vGRNdRk0h8',
    disablehttpcheck: 'true',
    redirectUri: 'https://mapnavigator-uat.verisk.com/implicit/callback',
    apiUrl:
      'https://api-us.accept.casualty.claims.verisk.com/mspnavigator/map-api/v1/',
  },
};
